import createIcon from '../../createIcon';

/**
 * @component @name SpaceDashboard
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMjFINUMzLjkgMjEgMyAyMC4xIDMgMTlWNUMzIDMuOSAzLjkgMyA1IDNIMTFWMjFaTTEzIDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVYxMkgxM1YyMVpNMjEgMTBWNUMyMSAzLjkgMjAuMSAzIDE5IDNIMTNWMTBIMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpaceDashboard = createIcon('SpaceDashboard', [
  [
    'path',
    {
      d: 'M11 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H11V21ZM13 21H19C20.1 21 21 20.1 21 19V12H13V21ZM21 10V5C21 3.9 20.1 3 19 3H13V10H21Z',
      key: '1nf67s',
    },
  ],
]);

export default SpaceDashboard;
